import { Divider as DividerPrimitive } from 'component-library';

export const Divider = ({ ...props }) => {
  return <DividerPrimitive {...props} />;
};
